import { render, staticRenderFns } from "./OrderPlace.vue?vue&type=template&id=f24a81d0&scoped=true&"
import script from "./OrderPlace.vue?vue&type=script&lang=js&"
export * from "./OrderPlace.vue?vue&type=script&lang=js&"
import style0 from "./OrderPlace.vue?vue&type=style&index=0&id=f24a81d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24a81d0",
  null
  
)

export default component.exports